import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';

export const HeaderContentLoader: FC = () => (
  <ContentLoader
    speed={1}
    width="100%"
    height={189}
    viewBox="0 0 767 189"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <circle cx="32" cy="82" r="8" />
    <rect x="48" y="40" rx="2" ry="2" width="220" height="10" />
    <rect x="48" y="67" rx="2" ry="2" width="528" height="28" />
    <rect x="51" y="145" rx="2" ry="2" width="100" height="16" />
    <rect x="169" y="144" rx="2" ry="2" width="109" height="16" />
    <rect x="294" y="143" rx="2" ry="2" width="109" height="16" />
  </ContentLoader>
);
